import React from "react";
import FileService from "../../services/FileService";
import PropTypes from "prop-types";
import IconDownload from "../../layout/others/download.svg";
import { useTranslation } from "react-i18next";

const Download = ({ url, fileName }) => {
  const { t } = useTranslation();
  const downloadFile = (e) => {
    e.stopPropagation();
    FileService.DownloadFileBase64(url, false);
  };

  return (
    <div>
      <button
        type="button"
        onClick={downloadFile}
        className="action-button"
        title={t("Direct Download")}
      >
        <img src={IconDownload} alt="download" width="13px" height="22px" marginTop="-4px"/>
      </button>
    </div>
  );
};

export default Download;

Download.propTypes = {
  url: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired
};
